import { Component } from '@angular/core';
import { AdminSidebarComponent } from '../administration/admin-sidebar/admin-sidebar.component';
import { AdminPromptsComponent } from '../administration/admin-prompts/admin-prompts.component';

@Component({
  selector: 'administration',
  standalone: true,
  imports: [AdminSidebarComponent, AdminPromptsComponent],
  templateUrl: './administration.component.html',
  styleUrl: './administration.component.scss'
})
export class AdministrationComponent {

}
